<template>
  <el-container>
    <el-header>
      <login-area></login-area>
    </el-header>
    <el-main>
      <div class="logo">
        <div>
          <img src="../assets/images/logo.png" />
        </div>
        <div class="introduction">中国化机行业云计算知识库</div>
      </div>
      <div class="search">
        <el-input placeholder="请输入内容" v-model="searchText" @focus="changeFocus(true)" @blur="changeFocus(false)"
          @keyup.enter.native="searchInfo('click')" class="input-with-select">
          <el-select v-model="searchType" slot="prepend" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button slot="append" @click="searchInfo('click')">搜索</el-button>
        </el-input>
        <div class="focusBlock" v-if="isFocus">
          <div class="all" v-show="!searchText">
            <span>搜索记录</span>
            <ul>
              <li v-if="searchLogs.length == 0"><span>暂无数据</span></li>
              <li v-else v-for="(item, index) in searchLogs" :key="index" @mousedown="selectSearchLogs(index)">
                <span>{{ item.searchContent }}</span>
              </li>
            </ul>
          </div>
          <div class="all" v-show="searchText">
            <span>搜索结果</span>
            <ul>
              <li v-if="searchResults.length == 0"><span>暂无数据</span></li>
              <li v-else v-for="(item, index) in searchResults" :key="index" @mousedown="selectGoods(item.name, item.id)">
                <span v-html="item.goodsCatalogueIdname"></span>
                &nbsp;--&nbsp;
                <span v-html="item.title"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="catalogue">
        <router-link v-if="false" v-show="isLogin" tag="a" to=""
          :class="'myKnowledge' == activeCatalogue ? 'catalogueItem active' : 'catalogueItem'"
          @click="switchNavCatalogue('myKnowledge')">我的知识库</router-link>
        <router-link tag="a" :to="{ path: '/knowledgeMarket', query: { tabId: item.id } }" class="catalogueItem"
          v-for="(item, index) in catalogue" :key="index" @click="switchNavCatalogue(item.id)"
          :class="item.id == activeCatalogue ? 'catalogueItem active' : 'catalogueItem'">{{ item.name }}</router-link>
      </div>
      <!-- <div class="myKnoledge" v-if="false">
        <ul class="leftList">
          <li v-for="(item, index) in menuList" :class="item.type === activeMenu ? 'active' : ''" :key="index"
            @click="switchNav(item.type)">{{ item.name }}</li>
        </ul>
        <div class="rightDetail">
          <div>
            <div class="rightDetailItem1">
              <div class="index">1</div>
              <div class="KnoledgeDetail">
                <div class="time">
                  <div>一周前</div>
                  <div>2019.10.10 15：34</div>
                </div>
                <div class="KnoledgeImg">
                  <img src="../assets/images/u3984.png" />
                </div>
                <div class="KnoledgeDes">设备零部件快算</div>
                <div class="KnoledgeTitel">加热器（均无相变）换热面积计算</div>
                <div class="KnoledgePreferential">
                  <span>2019年8月15日前有效</span>
                  <span>可试用100次</span>
                </div>
              </div>
            </div>
            <div class="rightDetailItem2">
              <div class="index">2</div>
              <div class="KnoledgeDetail">
                <div class="time">
                  <div>一周前</div>
                  <div>2019.10.10 15：34</div>
                </div>
                <div class="KnoledgeImg">
                  <img src="../assets/images/u3984.png" />
                </div>
                <div class="KnoledgeDes">设备零部件快算</div>
                <div class="KnoledgeTitel">加热器（均无相变）换热面积计算</div>
                <div class="KnoledgePreferential">
                  <span>2019年8月15日前有效</span>
                  <span>可试用100次</span>
                </div>
              </div>
            </div>
            <div class="rightDetailItem3">
              <div class="index">3</div>
              <div class="KnoledgeDetail">
                <div class="time">
                  <span>一周前</span>
                  <span>2019.10.10 15：34</span>
                </div>
                <div class="KnoledgeTitel">加热器（均无相变）换热面积计算</div>
              </div>
            </div>
            <div class="rightDetailItem4">
              <div class="index">4</div>
              <div class="KnoledgeDetail">
                <div class="time">
                  <span>一周前</span>
                  <span>2019.10.10 15：34</span>
                </div>
                <div class="KnoledgeTitel">加热器（均无相变）换热面积计算</div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <a class="nextPage">下一页</a>
            <a class="footprint">
              <i class="iconfont icon-zuji"></i>
              <span>我的足迹</span>
            </a>
          </div>
        </div>
      </div> -->
    </el-main>
    <!-- 暂时不显示反馈按钮 -->
    <!-- <div class="feedBack" @click="goFeedBack" v-if="false">
      <i class="iconfont icon-fankui"></i>
      <span>反馈</span>
    </div> -->

    <!-- 首页备案信息显示区域 -->
    <div class="footer">
      <page-footer></page-footer>
    </div>

  </el-container>
</template>
<script>
import loginArea from '@/components/loginArea'
import pageFooter from '@/components/pageFooter.vue'
export default {
  components: {
    loginArea,
    pageFooter
  },
  data() {
    return {

      searchGoodsType: 0, // 1: 搜索结果为化学化工物料信息, 0: 其他;  @zz 新增 2023年12月2日 

      user: this.$store.state.user, //登录账号昵称
      isLogin: this.$store.state.islogined ? true : false, //是否已登录 true表示登录
      activeCatalogue: 'myKnowledge', //被激活的项
      activeMenu: 'myKnowledge', //被激活的项 (我的知识)
      options: [],
      catalogue: [],
      menuList: [],
      hotSearch: [],
      isFocus: false, //搜索框焦点
      searchResults: [], //动态搜索结果
      searchLogs: [], //搜索历史
      searchText: '', //搜索框文本
      searchType: '', //搜素框下拉选中值
      pageNo: this.$store.state.defaultPageNo != undefined ? this.$store.state.defaultPageNo : 0,
      pageSize: this.$store.state.defaultPageSize != undefined ? this.$store.state.defaultPageSize : 10
    }
  },
  watch: {
    // 如果 `searchText` 发生改变，这个函数就会运行
    searchText: function (newsearchText, oldsearchText) {
      if (newsearchText) { //有值才触发自动搜索
        this.searchInfo('auto');
      }
    }
  },
  created: function () { //登录后的状态数据 ，前台手动加，后台联调后删除这个方法
    this.searchText = '';
    //this.setOptions();
    //this.setCatalogue();
    this.setMenuList();
    this.setHotSearch();
    var params = {
      url: "/SJHG/publicplat/home/home/initHomeDisplayData",
      data_: {}
    };
    this.axiosPost(params);
  },
  beforeMount: function () { //登录后的状态数据 ，前台手动加，后台联调后删除这个方法
    var knowledge = {
      name: "我的知识库"
    }
    if (this.isLogin)
      this.catalogue.unshift(knowledge);

  },
  methods: {
    //异步请求
    axiosPost: function (params) {
      let this_ = this;
      let paramdata = {};
      paramdata.url = params.url;
      paramdata.data_ = params.data_; //json对象
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var resultdata = res.data.result;
          this_.loadAxiosPostData(resultdata);
        } else {
          console.log(res);
        }
      };
      paramdata.onFailed = function (res) {
        console.log(res);
      };
      this_.$axiosUtil.postServer(paramdata);
    },
    loadAxiosPostData: function (resultdata) {
      //加载异步请求结果
      var list_GoodsCatalogue = resultdata.list_GoodsCatalogue; //知识商品目录
      //将商品目录的数据字典id 替换成知识目录的数据字典id
      list_GoodsCatalogue.forEach(item => {
        // if (item.id == '15562452') {
        //   item.id = '15562339'
        // }
      });

      this.setCatalogue(list_GoodsCatalogue);
      //加载搜索框下拉选项
      this.setOptions(list_GoodsCatalogue);

      //当前登录人搜索记录
      var list_logsGoodsSearch = resultdata.list_logsGoodsSearch;
      this.searchLogs = list_logsGoodsSearch;

    },
    setCatalogue: function (data_) {
      //设置知识目录
      this.catalogue = data_;
    },
    setOptions: function (data_) {
      //设置搜索框下拉选项
      data_.forEach(item => {
        this.options.push({
          label: item.name,
          value: item.id
        });
      });
    },
    setHotSearch: function () {
      //设置热搜
      this.hotSearch = [{
        name: "加热器"
      }, {
        name: "mvr"
      }, {
        name: "加热器"
      }, {
        name: "加热器"
      }, {
        name: "加热器"
      }, {
        name: "加热器"
      }, {
        name: "加热器"
      }];
    },
    setMenuList: function () {
      //设置搜索下拉框
      this.menuList = [{
        name: "我的知识",
        type: 'myKnowledge'
      }, {
        name: "我的建议",
        type: 'mySuggestion'
      }, {
        name: "热门知识",
        type: 'hotKnowledge'
      }, {
        name: "我的订购",
        type: 'myOrder'
      }, {
        name: "我的收藏",
        type: 'myCollection'
      }, {
        name: "我的点赞",
        type: 'myPraise'
      }, {
        name: "我的评价",
        type: 'myEvaluation'
      }, {
        name: "我的评论",
        type: 'myComments'
      }];
    },
    switchNavCatalogue(index) { //切换导航项
      console.log("switchNavCatalogue => index", index);
      this.activeCatalogue = index;
    },
    switchNav(index) { //切换导航项
      this.activeMenu = index;
    },
    changeFocus(val) {
      this.isFocus = val;
    },
    gouserRegistration() {
      this.$router.push("/userRegistration")
    },
    goLogin() {
      this.$router.push("/userLogin");
    },
    gomemberCenter() {
      this.$router.push("/memberCenterIndex")
    },
    goFeedBack() {
      this.isLogin = true;
    },
    goTest() {
      //this.$router.push("/test")
    },
    logOut() {
      this.$store.commit('LOGOUT', ''); //退出登录
      this.user = this.$store.state.user; //登录账号昵称
      this.isLogin = this.$store.state.islogined ? true : false; //是否已登录 true表示登录
      this.$router.push("/"); //回到首页
    },
    //搜索 f：click 点击搜索按钮触发 （存搜索历史）   auto；不点击搜索框触发（不存搜索历史）
    searchInfo(f) {
      let this_ = this;
      let searchText = this_.searchText;
      let searchType = this_.searchType;
      // if(searchType==''&&(searchText===''||searchText.length===0)){
      //   this_.$message.info('请录入搜索信息');
      //   return;
      // }
      //无搜索信息跳转知识市场
      if (f == 'click') {

        /********* @zz 修改（新增）当搜索结果属于化学化工物料数据则跳转第一个搜索结果 2023年12月2日 *********/

        if (this.searchGoodsType === 1) {
          this.$router.push({
            path: "/algorithmDetail",
            query: {
              "id": this_.searchResults[0].id
            }
          });
          return;
        }

        /************** 结束 ************/

        //搜索文本框有值存搜索历史
        this_.saveSearchLogs(searchText);
        this_.redrectUrl(searchText, searchType);
        return;
      } else {
        //搜索
        //更新查询参数
        let data_ = {
          'pageNo': this_.pageNo,
          'pageSize': this_.pageSize,
          'searchText': this_.searchText,
          'searchType': this_.searchType,
          "savelog": f
        };

        //组装查询
        let paramdata = {};
        paramdata.url = '/SJHG/publicplat/home/home/searchGoodsList';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function (res) {
          if (res.data.ok) {
            let resultdata = res.data.result;
            let datalist = resultdata.page.list;
            let searchResults_ = [];
            this_.searchResults = searchResults_;
            if (datalist && datalist.length > 0) {
              this_.searchGoodsType = 0;
              datalist.forEach(item => {
                let goodsCatalogueIdname = item.goodsCatalogueId.name == undefined ? '' : item.goodsCatalogueId
                  .name;
                let newTitle = this_.newStr(searchText, item.name);
                let newGoodsCatalogueIdname = this_.newStr(searchText, goodsCatalogueIdname);
                searchResults_.push({
                  'id': item.id,
                  'goodsCatalogueIdname': newGoodsCatalogueIdname,
                  'title': newTitle,
                  'name': item.name
                });
              });
            } else {
              // TODO 首页 查询结果为空,继续查询化学化工物性数据

              paramdata.url = '/SJHG/publicplat/home/home/getQueryTreeDataList';
              data_.rootid = 15562339;
              paramdata.onSuccess = function (res) {
                if (res.data.ok) {
                  let resultdata = res.data.result;
                  let searchResults_ = [];
                  if (resultdata.length > 0) {
                    this_.searchGoodsType = 1;
                    resultdata.forEach(item => {
                      let goodsCatalogueIdname = item.catalogueName == undefined ? '' : item.catalogueName;
                      let newTitle = this_.newStr(searchText, item.title);
                      let newGoodsCatalogueIdname = this_.newStr(searchText, goodsCatalogueIdname);
                      searchResults_.push({
                        'id': item.id,
                        'goodsCatalogueIdname': newGoodsCatalogueIdname,
                        'title': newTitle,
                        'name': item.title
                      });
                    });
                    this_.searchResults = searchResults_;
                  }
                } else {
                  console.log('首页查询化学化工物性数据失败');
                  this_.searchResults = []
                }
              }
              this_.$axiosUtil.postServer(paramdata);
            }
          } else {
            console.log('查询商品失败');
          }
        };
        paramdata.onFailed = function (res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      }
    },
    //匹配搜索高亮显示文本
    //searchText搜索的文本 target被匹配的项
    newStr(searchText, target) {
      let replaceReg = new RegExp(searchText, 'g'); // 匹配关键字正则
      let replaceString = "<a class='searchText'>" + searchText + "</a>";
      let newStr = target.replace(replaceReg, replaceString);
      return newStr
    },
    //选中搜素记录商品跳转商品查看页面
    selectGoods(val, id) {
      if (this.searchGoodsType === 1) {
        // @zz 新增 2023年12月2日
        console.log("跳转到化学物料搜索结果", val, id);
        this.$router.push({
          path: "/algorithmDetail",
          query: {
            "id": id
          }
        });
      } else {
        this.redrectUrl(val, this.searchType);
      }
    },
    selectSearchLogs(selectIndex) { //选中搜索历史
      let searchText_ = this.searchLogs[selectIndex] == undefined ? '' : this.searchLogs[selectIndex].searchContent;
      this.redrectUrl(searchText_, '');
    },
    saveSearchLogs(searchText_) { //保存搜索历史
      //有账号登录且搜索文本不空才存搜索历史
      if (!this.$store.state.userId || !searchText_) return;
      //保存搜搜索记录
      let paramdata = {};
      paramdata.url = '/SJHG/publicplat/home/home/saveLogsGoodsSearch';
      paramdata.data = {
        'searchText': searchText_,
        'savelog': 'click'
      }; //json对象
      paramdata.onSuccess = function (res) { };
      paramdata.onFailed = function (res) { };
      this.$axiosUtil.postServer(paramdata);
    },
    redrectUrl(searchText, searchType) { //带查询参数重定向"/knowledgeMarket"
      this.$router.push({
        path: "/knowledgeMarket",
        query: {
          "searchText": searchText,
          "searchType": searchType
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.el-container {
  height: 100%;
  background: #252B3A;
}

.iconfont {
  vertical-align: 0;
}

.el-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #bfbfbf;
  height: 60px;
  width: 1280px;
  margin: 0 auto;
  padding: 0px;
  padding-top: 20px;
  /* 保证和后面的面一致 */
}

.el-header>div {
  display: flex;
}

.el-header .memberCenter,
.el-header .user,
.el-header .messageCenter,
.el-header .login,
.el-header .register {
  margin: 0px 6px;
  cursor: pointer;
}

.el-header .login {
  color: $color-primary;
  padding: 8px 15px;
  border: 1px solid #626060;
}

.el-header .login:hover {
  background: $color-primary;
  color: #fff;
}

.el-header .register {
  background: $color-primary;
  color: #ffffff;
  border: 1px solid #626060;
  padding: 8px 15px;
}

.el-header .register:hover {
  background: $color-primary-light-1;
  color: #ffffff;
}

.memberCenter i {
  border: 1px solid;
  border-radius: 50%;
  padding: 3px;
  color: #fff;
  margin-right: 5px;
  vertical-align: 0;
}

.messageCenter i {
  font-size: 20px;
}

.user {
  display: flex;
}

.user svg {
  font-size: 25px;
  margin-right: 5px;
}

.el-header .memberCenter:hover,
.el-header .user:hover,
.el-header .messageCenter:hover {
  color: #fff;
}

.el-main {
  width: 1280px;
  margin: 0 auto;
  padding: 0px;
}

.logo {
  color: #ffffff;
  text-align: center;
  margin-top: 130px;
}

.logo img {
  height: 100px;
}

.logo .introduction {
  margin-top: 15px;
  font-size: 18px;
}

.search {
  margin-top: 25px;
  text-align: center;
  position: relative;
}

.search>>>.el-input-group__prepend {
  background: #ffffff;
  border-radius: $border-radius;
  width: 60px;
}

.search>>>.el-input-group__append {
  background: $color-primary;
  border-radius: $border-radius;
  color: #fff;
}

.search>>>.el-input-group__append:hover {
  background: $color-primary-light-1;
}

.search .el-input__inner {
  border: none;
}

.search .input-with-select {
  width: 50%;
}

.search .el-select .el-input {
  width: 90px;
}

.catalogue {
  text-align: center;
  margin-top: 30px;
  color: #ffffff;
}

.catalogue:active {
  color: $color-primary;
}

.catalogueItem {
  margin: 0px 15px;
  position: relative;
  color: #fff;
  text-decoration: none;
}

.catalogueItem:hover {
  color: $color-primary;
  cursor: pointer;
}



.catalogueItem:hover:after {
  content: "";
  height: 2px;
  width: 100%;
  background: $color-primary;
  position: absolute;
  bottom: -20px;
  left: 0px;
}

.banquan {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}

.banquan>div {
  margin: 0 10px;
  font-size: 14px;
}

.banquan>div>div:first-child {
  margin-bottom: 5px;
}

.feedBack {
  position: fixed;
  bottom: 15vh;
  right: calc(20vw + 15px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ccc;
  width: 60px;
  height: 60px;
  align-items: center;
  background: #7A6E6E;
  color: #ffffff;
}

.feedBack:hover {
  color: #ffffff;
  background: $color-primary;
  cursor: pointer;
}

.feedBack i {
  padding: 8px;
}

.myKnoledge {
  width: 50%;
  margin: 0 auto;
  margin-top: 20px;
  background: #fff;
  display: flex;
}

.myKnoledge .rightDetail {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.rightDetail .rightDetailItem1,
.rightDetail .rightDetailItem2,
.rightDetail .rightDetailItem3,
.rightDetail .rightDetailItem4 {
  width: 48%;
  display: inline-flex;
  margin-top: 5px;
}

.index {
  padding: 0px 10px;
}

.KnoledgeDetail {
  font-size: 14px;
  border: 1px solid $color-primary;
}


.KnoledgeDetail .time {
  font-size: 12px;
  text-align: right;
  padding-right: 20%;
  padding-left: 10px;
}

.rightDetailItem3 .KnoledgeDetail .time {
  display: flex;
  justify-content: space-between;
  padding-right: 5%;
}

.KnoledgeDes {
  background: $color-primary;
  border: $color-primary;
  padding: 3px;
  margin-right: 20%;
  margin-left: 10px;
}

.KnoledgeTitel {
  padding-right: 20%;
  margin-left: 10px;
}

.KnoledgeTitel:hover {
  cursor: pointer;
  text-decoration: underline;
  color: $color-primary;
}

.rightDetailItem3 .KnoledgeDetail .KnoledgeTitel {
  padding-right: 5%;
}

.KnoledgeImg {
  margin-left: 10px;
}

.KnoledgeImg img {
  width: calc(100% - 10px);
}

.myKnoledge ul {
  background: #F7F7F7;
  display: inline-block;
  padding: 5px;
}

.myKnoledge ul li {
  border-bottom: 1px solid #ffffff;
  padding: 12px 10px;
}

.myKnoledge ul li:hover {
  background: #FFFFFF;
  color: $color-primary;
  cursor: pointer;
}

.myKnoledge ul li.active {
  background: #ffffff;
  color: $color-primary;
}

.KnoledgePreferential {
  font-size: 12px;
  border-top: 1px solid $color-primary;
  display: flex;
}

.KnoledgePreferential>span:first-child {
  display: flex;
  align-items: center;
  background: #FAFAFA;
  padding: 4px 3px;
  color: $color-primary;
}

.KnoledgePreferential>span:last-child {
  background: $color-primary;
  color: #ffffff;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rightDetail .bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 1;
}

.bottom a:hover {
  color: $color-primary;
  text-decoration: underline;
  cursor: pointer;
}

.bottom .footprint {
  position: absolute;
  right: 10px;
}

.icon-zuji {
  color: $color-primary;
  vertical-align: 0;
}

.focusBlock {
  position: absolute;
  left: 25%;
  top: 40px;
  width: calc(50% - 2px);
  background: #ffffff;
  border: 1px solid $color-primary;
  z-index: 2;
}

.searchRecords,
.hotSearch,
.all {
  display: flex;
  // align-items: center;
  max-height: 40vh;
  overflow: scroll;
}

.searchRecords>span,
.hotSearch>span {
  background: $color-primary;
  color: #fff;
}

.searchRecords>span,
.hotSearch>span,
.all>span {
  width: 100px;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}

.searchRecords>span {
  height: 27px;
  line-height: 27px;
  border-bottom: 1px solid #ffffff;
}

.hotSearch>span {
  line-height: 28px;
}

.searchRecords>div,
.hotSearch>div {
  display: flex;
  justify-content: space-around;
  flex: 1;
  border-bottom: 1px solid $color-primary;
  border-left: 1px solid $color-primary;
  padding: 3px 0px;
  color: #5b5a5a;
}

.searchRecords>div>span:hover,
.hotSearch>div>span:hover {
  color: $color-primary;
  cursor: pointer;
}

.all ul {
  flex: 1;
  text-align: initial;
  border-left: 1px solid $color-primary;
  padding-left: 2px;
}

.all ul li {
  padding: 10px;
}

.all ul li:hover {
  background: $color-primary;
  color: #ffffff;
  cursor: pointer;
}

.all ul li:hover>span:first-child {
  color: #ffffff;
}

// .all ul li:hover>span:last-child {
//   color: #ffffff;
// }

.all ul li>span:first-child {
  color: #FFA128;
}

// .all ul li>span:last-child {
//   color: #F6877F;
// }
.all ul li>>>.searchText {
  color: #f66f6a;
}

.all ul li:hover>>>.searchText {
  color: #ffffff;
}

.strong {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue